export enum ShipStatus {
  Laden = 1,
  Ballast = 2,
}
